var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.countDaysFreeTrialDuration > 0
    ? _c("div", { staticStyle: { direction: "ltr" } }, [
        !_vm.isMobile && !_vm.isSmallMobile && _vm.showGraphic
          ? _c(
              "div",
              {
                staticClass:
                  "br-50 rounded-right-0 position-relative text-left",
                staticStyle: {
                  height: "20px",
                  background:
                    "linear-gradient(90deg, #00c851 60%, #00c851 80%, #00c85100)",
                  "margin-bottom": "5rem",
                  "margin-top": "2rem",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-75 h-100 position-relative d-inline-block br-50 bg-success",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "position-absolute",
                        staticStyle: { bottom: "calc(100% + 0.5rem)" },
                      },
                      [
                        _c("br"),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm._f("trans")("Today"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "position-absolute bg-white left-0",
                      staticStyle: {
                        height: "22px",
                        width: "22px",
                        top: "-1px",
                        "border-radius": "100%",
                        "box-shadow": "rgba(0, 0, 0, 0.2) 0 0 4px 1px",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "position-absolute left-0",
                        staticStyle: { top: "calc(100% + 0.5rem)" },
                        style: `max-width: calc(100% * ${
                          _vm.countDaysReminderBeforeTrialEnd
                        } / ${2 * _vm.countDaysFreeTrialDuration});`,
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("trans")("%count% day trial starts", {
                                "%count%": _vm.countDaysFreeTrialDuration,
                              })
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "position-absolute",
                        staticStyle: {
                          height: "140%",
                          "box-sizing": "border-box",
                          "padding-left": "3px",
                          background: "rgb(46, 46, 46)",
                          "border-left": "2px solid whitesmoke",
                          "border-right": "2px solid whitesmoke",
                        },
                        style: `left: calc(100% * ${
                          _vm.countDaysFreeTrialDuration -
                          _vm.countDaysReminderBeforeTrialEnd
                        } / ${_vm.countDaysFreeTrialDuration});`,
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "position-absolute",
                            staticStyle: {
                              top: "100%",
                              left: "-0.5ch",
                              width: "100vw",
                              "max-width": "100px",
                            },
                          },
                          [
                            _c("i", { staticClass: "far fa-envelope" }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm._f("trans")("%count% day reminder", {
                                    "%count%":
                                      _vm.countDaysReminderBeforeTrialEnd,
                                  })
                                )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "position-relative d-inline-block h-100 z-index-1",
                    staticStyle: { width: "22px", "margin-left": "-22px" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "position-absolute white-space-nowrap text-center",
                        staticStyle: {
                          bottom: "calc(100% + 0.5rem)",
                          left: "-50%",
                        },
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.dateFirstChargeShort))])]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "position-absolute bg-white left-0",
                      staticStyle: {
                        height: "22px",
                        width: "22px",
                        top: "-1px",
                        "border-radius": "100%",
                        "box-shadow": "rgba(0, 0, 0, 0.2) 0 0 4px 1px",
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "position-absolute white-space-nowrap text-center",
                        staticStyle: {
                          top: "calc(100% + 0.5rem)",
                          left: "-50%",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm._f("trans")("First bill")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("ul", { staticClass: "list-unstyled mb-0" }, [
          _c("li", { staticClass: "py-2 d-flex align-items-baseline" }, [
            _c("i", { staticClass: "fa fa-check text-success" }),
            _vm._v(" "),
            _c("span", { staticClass: "pl-1" }, [
              _vm._v(
                _vm._s(
                  _vm._f("trans")(
                    "We'll remind you %count% days before the free trial ends.",
                    { "%count%": _vm.countDaysReminderBeforeTrialEnd }
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "py-2 d-flex align-items-baseline" }, [
            _c("i", { staticClass: "fa fa-check text-success" }),
            _vm._v(" "),
            _c("span", {
              staticClass: "pl-1",
              domProps: { innerHTML: _vm._s(_vm.noChargeUntilText) },
            }),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "py-2 d-flex align-items-baseline" }, [
            _c("i", { staticClass: "fa fa-check text-success" }),
            _vm._v(" "),
            _c("span", {
              staticClass: "pl-1",
              domProps: { innerHTML: _vm._s(_vm.youWillPayText) },
            }),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }